// @ts-nocheck
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import translate from "@insite/client-framework/Translate";
import { DynamicDropdownPresentationProps } from "@insite/mobius/DynamicDropdown";
import uniqueId from "@insite/mobius/utilities/uniqueId";
import updateDraftParameter from "@store/Framework/Store/Greif/Pages/ShipmentHistory/Handlers/UpdateDraftParameter";
import { useShipmentHistoryState } from "@store/Framework/Store/Greif/Pages/ShipmentHistory/ShipmentHistoryHooks";
import { useFilterDrawerContext } from "@store/Library/Components/FilterDrawerAndButton";
import FilterDrawerSection from "@store/Library/Components/FilterDrawerSection";
import SearchShipToField from "@store/Library/Components/SearchShipToField";
import { filterDrawerProps } from "@store/Themes/common/props/filterDrawer";
import React, { FC, useMemo } from "react";

export interface ShipmentHistoryFilterFieldShipToProps {}

export interface ShipmentHistoryFilterFieldShipToStyles {
    searchShipToField?: DynamicDropdownPresentationProps;
}

export const shipmentHistoryFilterFieldShipToStyles: ShipmentHistoryFilterFieldShipToStyles = {
    searchShipToField: filterDrawerProps.dynamicDropdown,
};

const styles = shipmentHistoryFilterFieldShipToStyles;

const ShipmentHistoryFilterFieldShipTo: FC<ShipmentHistoryFilterFieldShipToProps> = () => {
    const dispatch = useAppDispatch();
    const { scrollElement } = useFilterDrawerContext();
    const { customerSequence } = useShipmentHistoryState().draftParameter;
    const id = useMemo(uniqueId, []);

    return (
        <FilterDrawerSection title={translate("Ship To")} labelFor={id}>
            <SearchShipToField
                {...styles.searchShipToField}
                data-test-selector="shipmentHistory_filterShipTo"
                onSelectionChange={customerSequence => {
                    dispatch(updateDraftParameter({ customerSequence }));
                }}
                placeholder={translate("Search or Select Ship To")}
                scrollElement={scrollElement}
                selected={customerSequence}
                uid={id}
            />
        </FilterDrawerSection>
    );
};

export default ShipmentHistoryFilterFieldShipTo;
